
  import * as ipxRuntime$VltJHGg7VhaU7yV_6lWCXJrRjxK9uPEb_poDHKLH1D8 from '/app/node_modules/.pnpm/@nuxt+image@1.11.0/node_modules/@nuxt/image/dist/runtime/providers/ipx'
  
  export const imageOptions = {
    ...{
  "screens": {
    "xs": 320,
    "sm": 640,
    "md": 768,
    "lg": 1024,
    "xl": 1280,
    "xxl": 1536,
    "2xl": 1536
  },
  "presets": {},
  "provider": "ipx",
  "domains": [],
  "alias": {},
  "densities": [
    1,
    2
  ],
  "format": [
    "webp"
  ],
  "quality": 80
},
    providers: {
        ['ipx']: { provider: ipxRuntime$VltJHGg7VhaU7yV_6lWCXJrRjxK9uPEb_poDHKLH1D8, defaults: {} }
    }
  }
